import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SetCard } from 'src/app/shared/models/node';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-card',
  templateUrl: './sample-card.component.html',
  styleUrls: ['./sample-card.component.scss']
})
export class SampleCardComponent implements OnInit {

  @Input() block: SetCard = {} as SetCard;
  public domainWebsite = environment.urlApi;
  public isLinkEsternal: boolean = false;

  constructor(
    private router: Router, 
    private nodeService: NodeService, 
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.isLinkEsternal = this.block.link_card ? this.nodeService.verifyLinkExternal(this.block.link_card.url) : false;
  }

  navigateTo() {
    if (this.isLinkEsternal && this.block.link_card) {
      window.open(this.block.link_card.url, '_blank')
    } else if (this.block && this.block.link_card && this.block.link_card.url) {
      this.router.navigateByUrl(this.block.link_card.url);
    }
  }

  externalUrl(event: any, url: string) {
    event.stopPropagation();
    window.open(url, '_blank')
  }

  public extractImageSrc(htmlString: string) {
    let imgSrc: any = "";
    if (this.nodeService.isBrowser) {
      let parser = new DOMParser();
      let htmlDoc = parser.parseFromString(htmlString, 'text/html');
      imgSrc = htmlDoc.querySelector('img')?.getAttribute('src');
    }
    return imgSrc;
  }

}
